import type { EmotionCache } from '@emotion/react';
import { CacheProvider as EmotionCacheProvider } from '@emotion/react';
import type { ProviderProps } from 'react';

export const CacheProvider = ({ ...props }: ProviderProps<EmotionCache>) => {
  return <EmotionCacheProvider {...props} />;
};
